import React, { Component } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  CloseButton,
  Collapse
} from '@chakra-ui/react';

class OfflineBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnline: true,
      isDismissed: false,
      checkInterval: null
    };
  }

  componentDidMount() {
    // Check connectivity on mount
    this.checkConnectivity();

    // Set up periodic connectivity checks (every 30 seconds)
    const interval = setInterval(() => {
      this.checkConnectivity();
    }, 30000);

    this.setState({ checkInterval: interval });

    // Listen to online/offline events
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    // Clear interval
    if (this.state.checkInterval) {
      clearInterval(this.state.checkInterval);
    }

    // Remove event listeners
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }

  checkConnectivity = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/health`, {
        method: 'GET',
        signal: AbortSignal.timeout(5000) // 5 second timeout
      });

      if (response.ok) {
        this.setState({ isOnline: true, isDismissed: false });
      } else {
        this.setState({ isOnline: false });
      }
    } catch (error) {
      // Network error or timeout
      this.setState({ isOnline: false });
    }
  };

  handleOnline = () => {
    this.setState({ isOnline: true, isDismissed: false });
    this.checkConnectivity(); // Verify backend is actually reachable
  };

  handleOffline = () => {
    this.setState({ isOnline: false });
  };

  handleDismiss = () => {
    this.setState({ isDismissed: true });
  };

  render() {
    const { isOnline, isDismissed } = this.state;

    // Don't show banner if online or dismissed
    if (isOnline || isDismissed) {
      return null;
    }

    return (
      <Collapse in={!isOnline && !isDismissed} animateOpacity>
        <Alert status="error" variant="solid" mb={4}>
          <AlertIcon />
          <Box flex="1">
            <AlertTitle>Geen verbinding met server</AlertTitle>
            <AlertDescription display="block">
              De server is momenteel niet bereikbaar. Controleer je internetverbinding
              of probeer het later opnieuw.
            </AlertDescription>
          </Box>
          <CloseButton
            alignSelf="flex-start"
            position="relative"
            right={-1}
            top={-1}
            onClick={this.handleDismiss}
          />
        </Alert>
      </Collapse>
    );
  }
}

export default OfflineBanner;
